import React from 'react'

function Icon() {
  return (
    <svg
      width="22px"
      height="21px"
      viewBox="0 0 22 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Icon/dinner</title>
      <defs>
        <linearGradient x1="50%" y1="100%" x2="50%" y2="0%" id="linearGradient-1">
          <stop stopColor="#FF636D" offset="0%"></stop>
          <stop stopColor="#FFC33D" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g id="Icon/dinner" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-2" fillRule="nonzero">
          <rect
            id="prefix__a"
            fill="url(#linearGradient-1)"
            x="0"
            y="0"
            width="21"
            height="21"
            rx="10.5"
          ></rect>
          <g id="Clipped" transform="translate(0.000000, 4.000000)" fill="#FFFFFF">
            <path
              d="M10.9245496,0.00199728949 C10.9089391,0.00497249611 10.8924104,0.00993117379 10.8786365,0.0148898515 C10.704167,0.0605096862 10.5829565,0.239022083 10.5866296,0.442327868 L10.5866296,3.00398076 C10.5857113,3.15769977 10.6554991,3.30150142 10.7721183,3.37984853 C10.8878191,3.45621217 11.0310678,3.45621217 11.1467687,3.37984853 C11.2633878,3.30050969 11.3331757,3.15769977 11.3322574,3.00398076 L11.3322574,0.442327868 C11.3359304,0.319352661 11.2927722,0.200344397 11.2156383,0.117038612 C11.1366678,0.0317493556 11.0310678,-0.00990353695 10.9245496,0.00199728949 L10.9245496,0.00199728949 Z M5.66291478,2.52398076 C5.51782957,2.54084026 5.39386435,2.65290638 5.34703304,2.8096006 C5.29928348,2.96827828 5.33785043,3.14282374 5.44161391,3.25786506 L7.01367652,5.05885679 C7.10366609,5.18579894 7.24783304,5.24431134 7.3874087,5.20761712 C7.52514783,5.17092291 7.63533913,5.04596423 7.66656,4.88728655 C7.69869913,4.72761712 7.64819478,4.56199729 7.53800348,4.45885679 L5.96502261,2.65687332 C5.89523478,2.5725758 5.79973565,2.52596423 5.69689043,2.52398076 L5.66383304,2.52398076 L5.66291478,2.52398076 Z M16.174247,2.52398076 C16.089767,2.53687332 16.0107965,2.58546836 15.9529461,2.65687332 L14.3818017,4.45885679 C14.2716104,4.56199729 14.2201878,4.72662539 14.252327,4.88728655 C14.2844661,5.04596423 14.3928209,5.17092291 14.5314783,5.20761712 C14.6710539,5.24431134 14.8152209,5.18579894 14.9052104,5.05885679 L16.4763548,3.25786506 C16.5865461,3.13588159 16.6205217,2.94745183 16.5608348,2.78579894 C16.5029843,2.62414605 16.3615722,2.52100555 16.2091409,2.52398076 L16.174247,2.52398076 Z M10.9594435,4.71274109 C9.03109565,4.71274109 7.44525913,6.40067498 7.25793391,8.55472456 L0.372813913,8.55472456 C0.168041739,8.55472456 0,8.74513779 0,8.98216258 C0,9.21918737 0.168041739,9.40860886 0.372813913,9.40860886 L21.4074157,9.40860886 C21.6140243,9.40860886 21.7802296,9.21918737 21.7802296,8.98216258 C21.7802296,8.74513779 21.6149426,8.5557163 21.4074157,8.5557163 L14.660953,8.5557163 C14.4736278,6.40067498 12.886873,4.71274109 10.9594435,4.71274109 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Icon
